import { useContext, useEffect, useState } from "react";
import { AdminPersonsResponse, AdminQueryApprovers } from "../../../backend/src/api/dto";
import { AdminAddApproverToUserFunction, AdminReloadFunction } from "../interfaces";
import API from "../API";
import { useForm } from "react-hook-form";
import { ModalContext } from "../ModalContext";
import Modal from ".";


type FormValues = {
    personId: number | string
}



function AdminAddApproverToUser({ item, reload, alreadyAdded, addFunction }: {
    item: any,
    reload: AdminReloadFunction,
    alreadyAdded: AdminQueryApprovers[],
    addFunction: AdminAddApproverToUserFunction,

}) {
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [data, setData] = useState<AdminPersonsResponse>();
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)

    const [showModal, closeModal] = useContext(ModalContext);
    const { register, control, handleSubmit, getValues, } = useForm<FormValues>({
        defaultValues: {
            // startDate: '',
            // endDate: ''
        }
    })


    useEffect(() => {
        API.getPersons({}).then(data => {
            setData(data)
        })
    }, [])

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),

            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const onSubmit = () => {
        const form = getValues();


        setSending(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data) => {
                //  console.log({ data: getValues() })


                setLoading(false);
                setApiResult({
                    status: true,
                })
                addFunction(data.personId).then(() => {
                    if (reload) {
                        console.log('in reload')
                        reload().then(() => {
                            closeModal(null);
                            resolve(1)
                        })
                    } else {
                        closeModal(null);
                        resolve(1)
                    }
                }).catch((e: any) => {
                    setLoading(false);
                    setApiResult(e)
                    resolve(1)
                })



                setSending(false)
            })()
        })

    }





    return (



        <Modal
            buttons={modalButtons}
            title={'Pridať Schvalovatela k osobe'}
            errorObject={apiResult}
            disableAllButtons={sending}
        >
            <form style={{ minHeight: '300px' }}>

                <div className="row mb-2">
                    <div className="col-4 text-end mt-2">
                        Schvalovateľ
                    </div>
                    <div className="col-8">
                        <select className="form-select" {...register("personId")} >
                            <option value="">[ Vybrať ]</option>
                            {
                                data?.persons.filter(person => {
                                    return alreadyAdded.findIndex(item => item.personId === person.personId) === -1 && person.adminLevel > 0

                                }).map(person => {
                                    return (
                                        <option value={person.personId}>{person.name} {person.surname}</option>
                                    )
                                })
                            }
                        </select>
                        <div className="form-text">
                            Schvalovateľ: Osoba s Admin Level &gt;= 1
                        </div>
                    </div>
                </div>



            </form>
        </Modal>


    )

}

export default AdminAddApproverToUser
